import React from 'react';

class Error extends React.Component{
    //&nbsp;<i className="fas fa-sync-alt float-left" aria-hidden="true">
    render(){

        return (
            <div className="page-content g-error">
                <h2>Virhe</h2>
                <p>{(this.props.msg || 'Some error happened.')}</p>
                {(typeof this.props.callback === 'function' ? <button onClick={this.props.callback} className="btn btn-secondary" >Try again<i className="material-icons">refresh</i></button> : '')}
            </div>
        )
    }
}

export default Error;